module.exports = __webpack_public_path__ + "sflyssofe.cbe27c99d3.svg";